import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar, { Navigation, useNavigation } from './Sidebar';
import { useMediaQuery } from './useMediaQuery';
import Header from './Header';
import ImpersonationBanner from '../ImpersonationBanner';
import './AppShell.css';

const AppShell: React.FC = () => {
  const location = useLocation();
  const mobile = useMediaQuery('(max-width: 1023px)');
  const small = useMediaQuery('(max-width: 640px)');
  const { navItems } = useNavigation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const closeMenu = () => { setSidebarOpen(false); menuRef.current?.querySelector<HTMLButtonElement>('.header .menu-btn')?.focus(); };
  useEffect(() => { setSidebarOpen(false); }, [location.pathname, mobile]);
  useEffect(() => {
    if (!mobile || !sidebarOpen) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const escape = (event: KeyboardEvent) => { if (event.key === 'Escape') closeMenu(); };
    document.addEventListener('keydown', escape);
    return () => { document.body.style.overflow = previous; document.removeEventListener('keydown', escape); };
  }, [mobile, sidebarOpen]);
  const toggleSidebar = () => setSidebarOpen(open => !open);

  return (
    <div className="app-shell" ref={menuRef}>
      {mobile && sidebarOpen && <button className="sidebar-backdrop" aria-label="Dismiss menu" onClick={closeMenu} />}
      {mobile && sidebarOpen && <Sidebar onNavigate={closeMenu} />}
      <div className="main-content">
        <ImpersonationBanner />
        <Header onMenuClick={toggleSidebar} menuOpen={sidebarOpen} />
        <main className="content-area">
          <Outlet />
        </main>
      </div>
      {small && <Navigation items={navItems.slice(0, 4)} label="Quick navigation" className="bottom-nav" />}
    </div>
  );
};

export default AppShell;
